import Game from "./scenes/Game";
import InputScreen from "./scenes/InputScreen";
import Intro from "./scenes/Intro";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Intro, InputScreen, Game],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Intro.KEY,
    //startScene: InputScreen.KEY,
    // startScene: Game.KEY,

    FREQUENCIES: {
      "Lorem": 1,
      "ipsum": 1,
      "dolor": 1,
      "sit": 2,
      "amet": 2,
      "consectetur": 1,
      "adipiscing": 1,
      "elit": 1,
      "Donec": 1,
      "tortor": 1,
      "neque": 1,
      "rhoncus": 1,
      "leo": 1,
      "tristique": 2,
      "rutrum": 1,
      "porttitor": 4,
      "sapien": 1,
      "Sed": 2,
      "iaculis": 1,
      "auctor": 1,
      "Fusce": 1,
      "placerat": 2,
      "purus": 1,
      "sed": 1,
      "mollis": 1,
      "mi": 2,
      "lorem": 1,
      "finibus": 1,
      "nunc": 1,
      "non": 1,
      "lacinia": 1,
      "est": 1,
      "lacus": 1,
      "metus": 1,
      "quis": 1,
      "velit": 1,
      "id": 1,
      "mauris": 1,
      "ornare": 2,
      "Maecenas": 1,
      "augue": 1,
      "et": 1,
      "urna": 1,
      "sagittis": 1,
      "Ut": 1,
      "convallis": 1,
      "turpis": 2,
      "vitae": 1,
      "fermentum": 1,
      "Aliquam": 1,
      "erat": 1,
      "volutpat": 1,
      "Mauris": 1,
      "tincidunt": 1,
      "sollicitudin": 1,
      "ultricies": 1,
      "orci": 1,
      "nec": 1
  },
    FILTER_ON: true,
    EDIT_SELECTED: false,
    WORD_LIST: [
      [
          "Lorem",
          1
      ],
      [
          "ipsum",
          1
      ],
      [
          "dolor",
          1
      ],
      [
          "sit",
          2
      ],
      [
          "amet",
          2
      ],
      [
          "consectetur",
          1
      ],
      [
          "adipiscing",
          1
      ],
      [
          "elit",
          1
      ],
      [
          "Donec",
          1
      ],
      [
          "tortor",
          1
      ],
      [
          "neque",
          1
      ],
      [
          "rhoncus",
          1
      ],
      [
          "leo",
          1
      ],
      [
          "tristique",
          2
      ],
      [
          "rutrum",
          1
      ],
      [
          "porttitor",
          4
      ],
      [
          "sapien",
          1
      ],
      [
          "Sed",
          2
      ],
      [
          "iaculis",
          1
      ],
      [
          "auctor",
          1
      ],
      [
          "Fusce",
          1
      ],
      [
          "placerat",
          2
      ],
      [
          "purus",
          1
      ],
      [
          "sed",
          1
      ],
      [
          "mollis",
          1
      ],
      [
          "mi",
          2
      ],
      [
          "lorem",
          1
      ],
      [
          "finibus",
          1
      ],
      [
          "nunc",
          1
      ],
      [
          "non",
          1
      ],
      [
          "lacinia",
          1
      ],
      [
          "est",
          1
      ],
      [
          "lacus",
          1
      ],
      [
          "metus",
          1
      ],
      [
          "quis",
          1
      ],
      [
          "velit",
          1
      ],
      [
          "id",
          1
      ],
      [
          "mauris",
          1
      ],
      [
          "ornare",
          2
      ],
      [
          "Maecenas",
          1
      ],
      [
          "augue",
          1
      ],
      [
          "et",
          1
      ],
      [
          "urna",
          1
      ],
      [
          "sagittis",
          1
      ],
      [
          "Ut",
          1
      ],
      [
          "convallis",
          1
      ],
      [
          "turpis",
          2
      ],
      [
          "vitae",
          1
      ],
      [
          "fermentum",
          1
      ],
      [
          "Aliquam",
          1
      ],
      [
          "erat",
          1
      ],
      [
          "volutpat",
          1
      ],
      [
          "Mauris",
          1
      ],
      [
          "tincidunt",
          1
      ],
      [
          "sollicitudin",
          1
      ],
      [
          "ultricies",
          1
      ],
      [
          "orci",
          1
      ],
      [
          "nec",
          1
      ]
  ],
    CURRENT_TEXT: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tortor neque, rhoncus in leo tristique, rutrum porttitor sapien. Sed iaculis porttitor auctor. Fusce placerat, purus sed porttitor mollis, mi lorem finibus nunc, non lacinia est lacus a metus. Sed quis velit id mauris porttitor ornare. Maecenas in augue et urna sagittis ornare. Ut convallis turpis vitae mi placerat fermentum. Aliquam erat volutpat. Mauris tincidunt sollicitudin turpis, sit amet ultricies orci tristique nec.",
    requestedFilteredWords:[],
    fonts: ['Asap',
    'Audiowide',
    'Barlow',
    'Bebas Neue',
    'BPreplay',
    'Komika',
    'Munson',
    'Orbitron',
    'Patrick Hand',
    'Roboto',
    'Rokkitt',
    'Teko'
    ]
}